export default __webpack_public_path__ + "static/media/book5.51a38067.jpg";